var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{style:(("width:" + _vm.width + "rem")),attrs:{"type":"is-danger has-text-weight-semibold","size":"is-small"},on:{"click":function($event){return _vm.$emit('cancel')}}},[_vm._v(_vm._s(_vm.$t('rebook-cancel-button-label')))])}
var staticRenderFns = []

export { render, staticRenderFns }